import { useEffect } from "react";

const CHANNEL_NAME = 'SN-data-change-channel';

/**
 * Notify that data of a certain type has changed.
 * Other parts of the app can listen for these notifications to trigger updates.
 *
 * @param type - The type of data that has changed (e.g., 'teams', 'team:123', 'place', 'event')
 */
export function notifyDataChange(type: string) {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(type);
}

/**
 * Notify multiple data changes. slightly more efficient when notifying several types at once.
 */
export function notifyDataChanges(types: string[]) {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    types.forEach(type => channel.postMessage(type));
}


/**
 * Receive a notification when data changes occur elsewhere in the app.
 * This can be used to trigger SWR revalidation or other updates.
 * 
 * Fun hack, you can modify the keysToWatch array to include different event names
 * without recreating the hook. (possibly storing in a ref if needed)
 */
export function useDataChangeNotifier(keysToWatch: string[], callback?: (type:string) => void) {
    useEffect(() => {
        const channel = new BroadcastChannel(CHANNEL_NAME);
        const handleMessage = (event: MessageEvent) => {
            const type = event.data;
            if (keysToWatch.includes(type)) {
                // console.log(`Data change detected for key: ${type}`);
                // Here you can trigger SWR revalidation or other updates as needed
                if (callback) {
                    callback(type);
                }
            }
        };
        channel.addEventListener('message', handleMessage);
        /* Cleanup on unmount */
        return () => {
            channel.removeEventListener('message', handleMessage);
        };
    }, [keysToWatch]);

    // // Function to notify data change
    // const notifyDataChange = (eventName: string, data?: any) => {
    //     window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    // };

    // return { notifyDataChange };
}